if (process.env.VUE_APP_ENV === 'production') {
    window.XMLHttpRequest.prototype.open = (function(open) {
        return function(method, url, async) {
            if (url.indexOf('/socket.io/?EIO=3&transport=polling') !== -1) {
                return false
            }
            open.apply(this, arguments)
        }
    })(XMLHttpRequest.prototype.open)
}

// const sentry = () => import('@/modules/sentry')
// sentry()

import '@/modules/yandexMetrika'

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

;(function() {
    if (typeof window.CustomEvent === 'function') return false

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null }
        var evt = document.createEvent('CustomEvent')
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
        return evt
    }

    window.CustomEvent = CustomEvent
})()

import Vue from 'vue'
Vue.config.devtools = true
import App from './App.vue'
import store from './store/store'
const validation = () => import('@/validation')
validation()

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

const CBem = () => import('@/components/CBem')

const CBtn = () => import('@/components/CBtn')
const CIcon = () => import('@/components/CIcon')
const CField = () => import('@/components/CField')
const CSpinner = () => import('@/components/CSpinner')

const MessageList = () => import('@/components/MessageList')

const MessageItem = () => import('@/components/MessageItem')

import VueResizeObserver from 'vue-resize-observer'
Vue.use(VueResizeObserver)

import { global } from '@/mixins/mixins'

Vue.mixin(global)

Vue.component('c-bem', CBem)
Vue.component('c-field', CField)
Vue.component('c-spinner', CSpinner)

Vue.component('c-btn', CBtn)
Vue.component('c-icon', CIcon)
Vue.component('message-item', MessageItem)

Vue.component('message-list', MessageList)

Vue.prototype.$emit_p = function(topic, varargs) {
    return new Promise((resolve, reject) => {
        const arr = Array.from(arguments)
        let invoked = false
        const promiseLike = {
            resolve: val => {
                if (!invoked) {
                    invoked = true
                    resolve(val)
                }
            },
            reject: val => {
                if (!invoked) {
                    invoked = true
                    reject(val)
                }
            }
        }

        arr.push(promiseLike)
        this.$root.$emit.apply(this, arr)
    })
}

Vue.config.productionTip = false

Vue.component('vnode', {
    functional: true,
    render(h, context) {
        if (context.data && context.data.staticClass) {
            if (context.props.node.data) {
                if (context.props.node.data.staticClass)
                    context.props.node.data.staticClass += ' ' + context.data.staticClass
                else context.props.node.data.staticClass = context.data.staticClass
            }
        }
        return context.props.node
    }
})

new Vue({
    store,
    render: h => h(App)
}).$mount('#effect-widget-app')
